import type { BannerItem } from "$root/components/banner-stack/types";
import type { FormatDate } from "$root/localization/formatters";
import type { TFunction } from "i18next";
import type { QuantityEditorBuilderProps } from "../builder";
import { unpricedCount } from "./pricing";

/**
 * Rows the editor could not price at the market date, which keep the composition from being
 * saved until the user picks another day or removes them. Only a quantity composition is priced, so
 * a weight composition's rows never carry the flag and the banner never applies there.
 */
export function unpricedRowsBanner({
	instrumentBuilder,
	t,
	formatDate,
}: {
	instrumentBuilder: Pick<QuantityEditorBuilderProps, "getComposition" | "getMarketDate">;
	t: TFunction;
	formatDate: FormatDate;
}): BannerItem | null {
	const count = unpricedCount(instrumentBuilder.getComposition({ removeDeleted: true }).values());
	if (count === 0) {
		return null;
	}
	return {
		id: "unpriced-rows",
		severity: "warning",
		title: t("EDIT_COMPOSITION.REFERENCE_DATE.UNPRICED_NOTICE.TITLE"),
		description: (
			<span data-qualifier="CompositionEditor/UnpricedRowsBanner">
				{t("EDIT_COMPOSITION.REFERENCE_DATE.UNPRICED_NOTICE.BODY", {
					count,
					date: formatDate(instrumentBuilder.getMarketDate().value),
				})}
			</span>
		),
	};
}
